import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 4.1 3.36',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M3.16,3.36H.06A.06.06,0,0,1,0,3.3V1A.06.06,0,0,1,.06.94h3.1A.06.06,0,0,1,3.22,1V3.3A.06.06,0,0,1,3.16,3.36Zm-3-.12h3V1.06h-3Z"
        />
        <path
          fill={fill}
          d="M2.94,3.14H.28a.06.06,0,0,1-.06-.06V1.22a.06.06,0,0,1,.06-.06H2.94A.06.06,0,0,1,3,1.22V3.08A.06.06,0,0,1,2.94,3.14ZM.34,3H2.88V1.28H.34Z"
        />
        <path
          fill={fill}
          d="M2.94,3.14l0,0-.75-.86L1.4,3.1A.06.06,0,0,1,1.31,3l.78-.9a.07.07,0,0,1,.09,0L3,3a.07.07,0,0,1,0,.09Z"
        />
        <path
          fill={fill}
          d="M1.74,2.69l-.05,0L1,1.86l-.66.75a.07.07,0,0,1-.09,0,.06.06,0,0,1,0-.08l.7-.8a.06.06,0,0,1,.09,0l.75.86a.05.05,0,0,1,0,.08Z"
        />
        <path
          fill={fill}
          d="M2.44,2a.21.21,0,0,1,0-.42.21.21,0,1,1,0,.42Zm0-.31a.1.1,0,0,0-.09.1.09.09,0,0,0,.09.09.09.09,0,0,0,.1-.09A.1.1,0,0,0,2.44,1.66Z"
        />
        <path
          fill={fill}
          d="M3.59,2.87H3.16a.05.05,0,0,1-.06-.06.06.06,0,0,1,.06-.06h.37V.57h-3V1a.06.06,0,0,1-.06.06A.06.06,0,0,1,.43,1V.51A.06.06,0,0,1,.49.45h3.1a.06.06,0,0,1,.06.06v2.3A.06.06,0,0,1,3.59,2.87Z"
        />
        <path
          fill={fill}
          d="M3.37,2.65H3.16a.05.05,0,0,1-.06-.06.06.06,0,0,1,.06-.06h.15V.79H.77V1a.06.06,0,0,1-.06.06A.06.06,0,0,1,.65,1V.73A.06.06,0,0,1,.71.67H3.37a.06.06,0,0,1,.06.06V2.59A.06.06,0,0,1,3.37,2.65Z"
        />
        <path
          fill={fill}
          d="M3.37,2.65a.06.06,0,0,1-.05,0l-.21-.24a.05.05,0,0,1,0-.08.06.06,0,0,1,.08,0l.21.24a.06.06,0,0,1,0,.09Z"
        />
        <path
          fill={fill}
          d="M4,2.42H3.61a.05.05,0,0,1-.06-.06.06.06,0,0,1,.06-.06H4V.12H1V.51a.06.06,0,0,1-.12,0V.06A.06.06,0,0,1,.94,0H4A.06.06,0,0,1,4.1.06v2.3A.06.06,0,0,1,4,2.42Z"
        />
        <path
          fill={fill}
          d="M3.82,2.2H3.61a.05.05,0,0,1-.06-.06.06.06,0,0,1,.06-.06h.15V.34H1.22V.51a.06.06,0,0,1-.12,0V.28A.06.06,0,0,1,1.16.22H3.82a.06.06,0,0,1,.06.06V2.14A.06.06,0,0,1,3.82,2.2Z"
        />
        <path
          fill={fill}
          d="M3.82,2.2a.06.06,0,0,1,0,0l-.21-.24a.05.05,0,0,1,0-.08.06.06,0,0,1,.08,0l.21.24a.07.07,0,0,1,0,.09Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
